import { createClient } from '@/lib/supabase/client';
import type { Supplier } from '@/lib/database';
import { newId, orThrow, DEFAULT_PAGE_SIZE } from './useEntityList';

// UI type matches DB columns exactly.
type SupplierRow = Supplier;

export async function listSuppliers(): Promise<Supplier[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('suppliers')
    .select('*')
    .limit(DEFAULT_PAGE_SIZE)
    .order('created_at', { ascending: false });
  return orThrow(data, error) as SupplierRow[];
}

export async function createSupplier(
  input: Omit<Supplier, 'id' | 'created_at' | 'balance_usd'> &
    Partial<Pick<Supplier, 'balance_usd'>>
): Promise<Supplier> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('suppliers')
    .insert({
      ...input,
      balance_usd: input.balance_usd ?? 0,
      id: newId('sup'),
      created_at: new Date().toISOString(),
    })
    .select('*')
    .limit(DEFAULT_PAGE_SIZE)
    .single();
  return orThrow(data, error) as SupplierRow;
}

export async function updateSupplier(
  id: string,
  patch: Partial<Omit<Supplier, 'id' | 'created_at'>>
): Promise<Supplier> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('suppliers')
    .update(patch)
    .eq('id', id)
    .select('*')
    .limit(DEFAULT_PAGE_SIZE)
    .single();
  return orThrow(data, error) as SupplierRow;
}
